import React, { useEffect, useState } from 'react';
import { Modal, ProgressBar, Row, Col, Form } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
const ProductionSummaryModal = ({ show, onHide }) => {
    const [production_summary, setProduction_summary] = useState([])
    const fetchProduction_summary = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            const response = await axios.get(`${config.API}/supervisor/productionsummaryshow`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            if (response?.data && response?.data?.success) {
                setProduction_summary(response?.data || []);
            } else {
                setProduction_summary([]);
            }
        } catch (err) {
            console.error("Error fetching fetchMaterialStaus:", err.message);
        }
    };
    useEffect(() => {
        fetchProduction_summary()
    }, [])


    return (
        <>
            <style>{`
                .custom-modal {
                    max-width: 700px;
                    width: 90%;
                }

                .custom-modal .modal-content {
                    max-height: 90vh;
                    overflow-y: auto;
                    border-radius: 16px;
                    padding: 16px;
                }

                .product-row {
                    border-bottom: 1px solid #dee2e6;
                    padding-bottom: 1rem;
                    margin-bottom: 1rem;
                }

                .styled-input input {
                    border: none !important;
                    background-color: #d1ecf1 !important;
                    border-radius: 6px;
                    font-weight: 500;
                }

                .styled-input input:focus {
                    box-shadow: none;
                }
            `}</style>

            <Modal show={show} onHide={onHide} size="lg" centered dialogClassName="custom-modal" className='font_family'>
                <Modal.Header closeButton>
                    <h4 className="fw-bold">Production Summary</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className="font_family">

                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <div className="text-muted">Date: {production_summary?.date}</div>
                                <div className="text-muted mb-3">Shift: {production_summary?.shift}</div>
                            </div>
                        </div>
                        <h6 className=" mb-3">Product Breakdown</h6>
                        {production_summary?.production_summary?.map((product, idx) => (
                            <Row key={idx} className="product-row align-items-center">
                                <Col xs={12} className="fw-bold">{product?.product?.name}</Col>
                                <div className="text-end">
                                    <small className="text-muted">Efficiency :-</small> {" "}
                                    <span className="mb-0 fw-bold">
                                        {product?.total_produced && product?.target
                                            ? `${((product.total_produced / product.target) * 100).toFixed(2)}%`
                                            : "0%"}
                                    </span>
                                </div>
                                <div className="text-muted small text-end">
                                    {product?.total_produced ?? 0} / {product?.target ?? 0}
                                </div>
                                <div><ProgressBar now={product?.total_produced} max={product?.target} style={{ height: "8px" }} /></div>
                                <Col md={4}>
                                    <Form.Group className="styled-input">
                                        <Form.Label className="text-muted small">Total Produced</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={product.total_produced ?? '0'}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="styled-input">
                                        <Form.Label className="text-muted small">Total Inspected</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={product.total_rejected ?? '0'}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="styled-input">
                                        <Form.Label className="text-muted small">Total NC</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={product.total_nc ?? '0'}

                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProductionSummaryModal;
